import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["count", "icon"]
  static values = { url: String, downUrl: String, removeUrl: String, active: Number }

  async upvote(event) {
    event.preventDefault()
    if (!this.urlValue) return

    const button = event.currentTarget
    if (button.disabled) return
    await this.sendVote(button, "upvote")
  }

  async downvote(event) {
    event.preventDefault()
    if (!this.downUrlValue) return

    const button = event.currentTarget
    if (button.disabled) return
    await this.sendVote(button, "downvote")
  }

  async sendVote(button, direction) {
    const isActiveUp = this.activeValue === 1 && direction === "upvote"
    const isActiveDown = this.activeValue === -1 && direction === "downvote"
    const url = (isActiveUp || isActiveDown) ? this.removeUrlValue : (direction === "upvote" ? this.urlValue : this.downUrlValue)
    const method = (isActiveUp || isActiveDown) ? "DELETE" : "POST"
    if (!url) return

    button.disabled = true
    try {
      const response = await fetch(url, {
        method,
        headers: {
          "X-CSRF-Token": this.csrfToken(),
          "Accept": "application/json"
        }
      })
      if (!response.ok) return
      const data = await response.json()
      if (this.hasCountTarget && typeof data.votes !== "undefined") {
        this.countTarget.textContent = data.votes
      }
      if (typeof data.user_vote !== "undefined") {
        this.activeValue = data.user_vote
      } else if (direction === "upvote") {
        this.activeValue = isActiveUp ? 0 : 1
      } else {
        this.activeValue = isActiveDown ? 0 : -1
      }
      this.syncButtons()
      this.runPulse(button)
    } finally {
      button.disabled = false
    }
  }

  csrfToken() {
    return document.querySelector("meta[name='csrf-token']")?.content
  }

  syncButtons() {
    const buttons = this.element.querySelectorAll("button[data-action*='discussion-vote#']")
    buttons.forEach((button) => {
      if (button.dataset.action.includes("upvote")) {
        this.updateButtonState(button, this.activeValue === 1, "Upvote", "Upvoted")
      } else if (button.dataset.action.includes("downvote")) {
        this.updateButtonState(button, this.activeValue === -1, "Downvote", "Downvoted")
      }
    })
  }

  updateButtonState(button, active, label, activeLabel) {
    const hiddenLabel = button.querySelector(".sr-only")
    if (hiddenLabel) {
      hiddenLabel.textContent = active ? activeLabel : label
    }
    const icon = button.querySelector(".vote-icon")
    if (icon) {
      icon.classList.toggle("vote-icon--active", active)
    }
    button.classList.toggle("bg-ink/10", active)
    button.classList.toggle("text-ink", active)
    button.classList.toggle("border-ink/30", active)
    button.classList.toggle("text-ink-muted", !active)
    button.classList.toggle("hover:border-ink-muted/80", !active)
    button.classList.toggle("hover:text-ink", !active)
    button.classList.toggle("font-semibold", active)
  }

  runPulse(button) {
    button.classList.remove("scale-100")
    button.classList.add("scale-105")
    setTimeout(() => {
      button.classList.remove("scale-105")
      button.classList.add("scale-100")
    }, 150)
  }
}
